(function () {
  function findTriggerButton(accountEl) {
    if (!accountEl.shadowRoot) return null;
    return accountEl.shadowRoot.querySelector(
      'button[popovertarget], button[aria-haspopup="dialog"], button[aria-haspopup], button'
    );
  }

  function findOpenSurface(accountEl) {
    if (!accountEl.shadowRoot) return null;
    return (
      accountEl.shadowRoot.querySelector('[popover]:popover-open') ||
      accountEl.shadowRoot.querySelector('dialog[open]')
    );
  }

  function isOpen(accountEl) {
    return !!findOpenSurface(accountEl);
  }

  function openAccount(accountEl) {
    if (isOpen(accountEl)) return;
    var btn = findTriggerButton(accountEl);
    if (btn) btn.click();
  }

  function ensureShadowAlignStyles(accountEl) {
    if (!accountEl.shadowRoot || accountEl.dataset.richDialogAlign === 'true') return;
    accountEl.dataset.richDialogAlign = 'true';

    var style = document.createElement('style');
    style.textContent =
      '[popover]:popover-open, dialog[open] {' +
      '  left: var(--pell-account-dialog-left, auto) !important;' +
      '  right: auto !important;' +
      '  inset-inline-start: var(--pell-account-dialog-left, auto) !important;' +
      '  inset-inline-end: auto !important;' +
      '  margin-inline-start: 0 !important;' +
      '  margin-inline-end: 0 !important;' +
      '}';
    accountEl.shadowRoot.appendChild(style);
  }

  function setDialogHorizontalPosition(accountEl, anchorEl) {
    var left = Math.round(anchorEl.getBoundingClientRect().left);
    accountEl.style.setProperty('--pell-account-dialog-left', left + 'px');

    var surface = findOpenSurface(accountEl);
    if (!surface) return;

    surface.style.left = left + 'px';
    surface.style.right = 'auto';
    surface.style.insetInlineStart = left + 'px';
    surface.style.insetInlineEnd = 'auto';
    surface.style.marginInlineStart = '0';
    surface.style.marginInlineEnd = '0';
  }

  function setDialogPosition(accountEl, anchorEl) {
    var rect = anchorEl.getBoundingClientRect();
    var top = Math.round(rect.bottom + 8);
    accountEl.style.setProperty('--shopify-account-dialog-position-top', top + 'px');
    setDialogHorizontalPosition(accountEl, anchorEl);
  }

  function schedulePositionUpdate(accountEl, anchorEl) {
    setDialogPosition(accountEl, anchorEl);
    requestAnimationFrame(function () {
      setDialogPosition(accountEl, anchorEl);
      requestAnimationFrame(function () {
        setDialogPosition(accountEl, anchorEl);
      });
    });
  }

  function initRichAccount(accountWrap) {
    var inner = accountWrap.querySelector('.header-actions-rich__account-inner');
    var accountEl = accountWrap.querySelector('shopify-account');
    if (!inner || !accountEl || accountWrap.dataset.richAccountInit === 'true') return;

    accountWrap.dataset.richAccountInit = 'true';

    function updatePosition() {
      schedulePositionUpdate(accountEl, accountWrap);
    }

    function onAccountReady() {
      ensureShadowAlignStyles(accountEl);
      updatePosition();
    }

    inner.addEventListener('click', function (event) {
      if (event.target.closest('shopify-account')) return;
      updatePosition();
      openAccount(accountEl);
    });

    accountEl.addEventListener('open', updatePosition);
    accountEl.addEventListener('toggle', updatePosition, true);
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition, { passive: true });

    if (typeof customElements !== 'undefined') {
      customElements.whenDefined('shopify-account').then(onAccountReady);
    } else {
      onAccountReady();
    }

    if (accountEl.shadowRoot) {
      onAccountReady();
    } else {
      var shadowObserver = new MutationObserver(function () {
        if (!accountEl.shadowRoot) return;
        shadowObserver.disconnect();
        onAccountReady();
      });
      shadowObserver.observe(accountEl, { childList: true });
    }
  }

  function boot() {
    document.querySelectorAll('.header-actions-rich__account--desktop').forEach(initRichAccount);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.header-actions-rich__account--desktop').forEach(initRichAccount);
  });
})();
